module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    staticClass: "assign-devices custom-scroll-bar"
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": "",
      "color": _vm.snackbarColor,
      "rounded": "",
      "centered": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n  ")]), _vm._v(" "), _c('v-col', {
    staticClass: "profile-pic-col",
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('div', {
    staticClass: "img-div"
  }, [_c('v-img', {
    staticClass: "profile-pic",
    attrs: {
      "id": "profile-pic",
      "height": "100%",
      "width": "100%",
      "src": _vm.profilePicSrc
    }
  })], 1)]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.$t('AssignDevices.title', [_vm.userData.name])))])])], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "place-content": "end"
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-2"
  }, [_c('v-row', {
    staticClass: "device-elements flex-nowrap",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    model: {
      value: (_vm.selectAll),
      callback: function($$v) {
        _vm.selectAll = $$v
      },
      expression: "selectAll"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mb-0 text-start break-normal"
  }, [_vm._v(_vm._s(_vm.$t('AssignDevices.selectAll')))])], 1)], 1)], 1), _vm._v(" "), (this.loadingDevices) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 50,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!this.loadingDevices) ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l((_vm.assignedDevices), function(device) {
    return _c('v-flex', {
      key: device.name,
      staticClass: "px-2",
      attrs: {
        "xs6": "",
        "sm4": "",
        "md3": "",
        "xl2": ""
      }
    }, [_c('v-row', {
      staticClass: "device-elements flex-nowrap"
    }, [_c('v-switch', {
      attrs: {
        "inset": "",
        "color": "#00D166"
      },
      model: {
        value: (device.isAssigned),
        callback: function($$v) {
          _vm.$set(device, "isAssigned", $$v)
        },
        expression: "device.isAssigned"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "mb-0 text-start"
    }, [_vm._v(_vm._s(device.campaign.entityName))])], 1)], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-6",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-btn', {
    staticClass: "text-none text-h6 font-weight-light",
    attrs: {
      "block": "",
      "color": "#0098E1",
      "large": "",
      "dark": "",
      "loading": this.loading
    },
    on: {
      "click": function($event) {
        _vm.isAssignedDevices.length ? _vm.nextStep() : _vm.saveUserData()
      }
    }
  }, [_vm._v(_vm._s(_vm.isAssignedDevices.length ? _vm.$t('AssignDevices.next') : _vm.$t('AssignDevices.save')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b746c62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddUser/AssignDevices.vue
// module id = 1704
// module chunks = 0